import { useCallback } from "react";
import { useIntl } from "react-intl";

export const FULL = {
  weekday: "long",
  day: "2-digit",
  month: "short",
  year: "numeric"
};

export const DATE = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
};

export const DATE_TIME = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit"
};

export const DAY_MONTH_TIME = {
  day: "2-digit",
  month: "long",
  hour: "2-digit",
  minute: "2-digit"
};

export default function useToLocaleDateString() {
  const { locale } = useIntl();

  return useCallback(
    (time, options) => {
      return time
        ? new Date(time).toLocaleDateString(locale, options)
        : undefined;
    },
    [locale]
  );
}

export function useToLocaleDateFull() {
  const toLocale = useToLocaleDateString();
  return useCallback(date => toLocale(date, FULL), [toLocale]);
}

export function useToLocaleDate() {
  const toLocale = useToLocaleDateString();
  return useCallback(date => toLocale(date, DATE), [toLocale]);
}

export function useToLocaleDateTime() {
  const toLocale = useToLocaleDateString();
  return useCallback(date => toLocale(date, DATE_TIME), [toLocale]);
}

export function useToLocaleDateAktivita() {
  const toLocale = useToLocaleDateString();
  return useCallback(date => toLocale(date, DAY_MONTH_TIME), [toLocale]);
}
